if (PJQ.app.module === "POD" || PJQ.app.module === "PRINTONDEMAND" || PJQ.app.module === "PJQPRINTONDEMAND") {
	PJQ.app.attachReadyEvent(function () {
		initPrintOnDemand(jQuery("#pjq-main"));
	});
}
else if (PJQ.app.module === PJQ.constants.modules.APP) {
	PJQ.modules.pjqPrintOnDemand = {
		routes: [
			{
				route: 'printondemand',
				name: 'printondemand',
				callback: function () {
					PJQ.app.initNavigator({
						activeItem: "printondemand"
					});
				}
			}
		]
	};
	PJQ.app.addRoutes(PJQ.modules.pjqPrintOnDemand.routes);
}